module.exports = __webpack_public_path__ + "img/q-img-5.ac3911df.jpg";